import * as FateActionTypes from 'actiontypes/fate';
import FateService from 'services/FateService';

/** ----------------------------------------------------------------------------
 * Change avatar
 -----------------------------------------------------------------------------*/

export const changeAvatar = service => (avatarName, history) => (dispatch) => {
  dispatch(changeAvatarRequested());

  return service.changeAvatar(avatarName).then(
    (response) => {
      dispatch(changeAvatarSuccess(response.data, history));
    },
    error => dispatch(changeAvatarFailure(error)),
  );
};

export default changeAvatar(new FateService());

export const changeAvatarRequested = () => ({
  type: FateActionTypes.CHANGE_AVATAR_REQUESTED,
  isFetching: true,
});

export const changeAvatarSuccess = (data, history) => ({
  type: FateActionTypes.CHANGE_AVATAR_SUCCESS,
  isFetching: false,
  payload: data,
});

export const changeAvatarFailure = error => ({
  type: FateActionTypes.CHANGE_AVATAR_FAILURE,
  isFetching: false,
  error: true,
  status: error.response && error.response.status,
});
